/**
 * GroupEmptyState — contextual empty state for the groups table.
 * @param {{ type: 'no-data' | 'no-results', onAddGroup?: () => void, onClearFilters?: () => void }} props
 */
const GroupEmptyState = ({ type, onAddGroup, onClearFilters }) => {
  if (type === 'no-data') {
    return (
      <div className="rp-empty">
        <div className="rp-empty__icon-wrap">
          <i className="fe fe-users rp-empty__icon-fe" aria-hidden="true" />
        </div>
        <h3 className="rp-empty__title">No groups yet</h3>
        <p className="rp-empty__text">
          Get started by creating your first resident group. Groups help organize residents for care plans, monitoring, and reporting.
        </p>
        {onAddGroup && (
          <button
            type="button"
            onClick={onAddGroup}
            className="rp-btn rp-btn--primary"
          >
            <i className="fe fe-plus" aria-hidden="true" />
            New Group
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="rp-empty">
      <div className="rp-empty__icon-wrap">
        <i className="fe fe-search rp-empty__icon-fe" aria-hidden="true" />
      </div>
      <h3 className="rp-empty__title">No results found</h3>
      <p className="rp-empty__text">
        No groups match your current search or filter criteria. Try adjusting your search terms or clearing filters.
      </p>
      {onClearFilters && (
        <button
          type="button"
          onClick={onClearFilters}
          className="rp-btn rp-btn--outline"
        >
          <i className="fe fe-x" aria-hidden="true" />
          Clear All Filters
        </button>
      )}
    </div>
  );
};

export default GroupEmptyState;
